const messages = {
  title: "Bonusmultiplikator",
  bandBonusTitle: "Bonus pr. dæk ved multiplikator",
  amountLabel: "Min. antal dæk (*)",
  label: "Bonusmultiplikator",
  desc: "Antal Bridgestone- og Firestone-dæk. Der er ingen bonus i euro på Firestone-dæk.",
  goals: {
    loyal: "Loyal",
    bronze: "Bronze",
    silver: "Sølv",
    gold: "Guld",
    platinum: "Platin",
  },
  andMore: "og mere",
  chooseTarget: "Vælg",
  selectTarget: "Vælg dit årsmål for {year} her:",
  multiplication: "Bonus multipliceres med <b>{factor}</b>",
  minTyres: "<b>Minimum:</b> {tyre} dæk",
};

export default {
  messages,
};
